import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
@keyframes spinner {
  from {
      transform: rotate(0)
  }
  to {
      transform: rotate(359deg)
  }
}

.Spinner {
  display: inline-block;
  border: 3px solid transparent;
  border-radius: 50%;
  border-right-color: ${colors.IconButtonPurple};
  animation: spinner .75s infinite cubic-bezier(.6,.2,0,.8);
}
`
